<style>
	.row {
		display: flex;
	}

	.centered {
		justify-content: center;
	}
</style>
<script>
  export let centered = false;
</script>

<div class="row" class:centered={centered}>
  <slot></slot>
</div>
